'use client'

/**
 * Staging environment badge — shown when NEXT_PUBLIC_APP_ENV=staging.
 * Renders a small pill in the sidebar footer instead of a full-width banner.
 */
export function StagingWatermark() {
  return null
}

export function StagingBadge() {
  const isStaging = process.env.NEXT_PUBLIC_APP_ENV === 'staging'
  if (!isStaging) return null

  return (
    <div className="mx-2 mb-1 flex items-center justify-center group-data-[collapsible=icon]:hidden">
      <span className="inline-flex items-center gap-1 rounded-full bg-amber-500/15 border border-amber-500/40 px-2 py-0.5 text-[10px] font-semibold text-amber-600 dark:text-amber-400 uppercase tracking-wide select-none">
        <span className="h-1.5 w-1.5 rounded-full bg-amber-500 animate-pulse" />
        Staging
      </span>
    </div>
  )
}
